import { createIcon } from '../createIcon';

export const EnviraIconConfig = {
  name: 'EnviraIcon',
  height: 512,
  width: 448,
  svgPath: 'M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z',
  yOffset: 0,
  xOffset: 0,
};

export const EnviraIcon = createIcon(EnviraIconConfig);

export default EnviraIcon;